'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selected = exports.Deselected = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-curly-brace-presence */
var Deselected = exports.Deselected = function (_PureComponent) {
  _inherits(Deselected, _PureComponent);

  function Deselected() {
    _classCallCheck(this, Deselected);

    return _possibleConstructorReturn(this, (Deselected.__proto__ || Object.getPrototypeOf(Deselected)).apply(this, arguments));
  }

  _createClass(Deselected, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          width = _props.width,
          color = _props.color,
          backgroundColor = _props.backgroundColor;


      return _react2.default.createElement(
        'svg',
        { width: width, height: width, viewBox: '0 0 24 24' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement('path', {
            id: 'radio-default-a',
            d: 'M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,\n            2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,\n            21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'black', strokeWidth: '0', fill: backgroundColor }),
          _react2.default.createElement('use', { fill: color, xlinkHref: '#radio-default-a' })
        )
      );
    }
  }]);

  return Deselected;
}(_react.PureComponent);

Deselected.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string
};

Deselected.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base,
  backgroundColor: 'none'
};

var Selected = exports.Selected = function (_PureComponent2) {
  _inherits(Selected, _PureComponent2);

  function Selected() {
    _classCallCheck(this, Selected);

    return _possibleConstructorReturn(this, (Selected.__proto__ || Object.getPrototypeOf(Selected)).apply(this, arguments));
  }

  _createClass(Selected, [{
    key: 'render',
    // eslint-disable-line react/no-multi-comp
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          color = _props2.color,
          backgroundColor = _props2.backgroundColor;


      return _react2.default.createElement(
        'svg',
        { width: width, height: width, viewBox: '0 0 24 24' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement('path', {
            id: 'selected-a',
            d: 'M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,\n            12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,\n            12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,\n            17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,\n            6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'black', strokeWidth: '0', fill: backgroundColor }),
          _react2.default.createElement('use', { fill: color, xlinkHref: '#selected-a' })
        )
      );
    }
  }]);

  return Selected;
}(_react.PureComponent);

Selected.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string
};

Selected.defaultProps = {
  width: '16px',
  color: _colors.teal.base,
  backgroundColor: 'none'
};